import styled from 'styled-components';
import constants from '../../parameters/constants';

export const FormRow = styled.div`
  padding: 10px 15px;
`;

export const CheckBoxStyles = {display: 'inline-block', width: 200};

export const NewButton = styled.div`
  position: absolute;
  padding: 0 10px;
  right:100px;
  top:0px;
  height:40px;
  font-size:25px;
  font-weight: 200;
  lineHeight: 40px;
  background: ${constants.primaryColor};
  a,a:hover{
    color:white;
  }
`;



// WEBPACK FOOTER //
// ./src/components/form/FormElements.js